import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { CompanyService } from './../../services/company.service';
import { FactLanguageService } from './../../services/fact-language.service';

import { EncrDecrService } from '../../services/encr-decr.service';
//import { ConsoleReporter } from 'jasmine';

@Component({
  selector: 'app-company-profile',
  templateUrl: './company-profile.component.html',
  styleUrls: ['./company-profile.component.css']
})
export class CompanyProfileComponent implements OnInit {

  @ViewChild('coverFilesInput') imgType: ElementRef;
  user_id: any = '';
  APIKEY: any = '';
  lastDay_of_Week: boolean = false;
  buttonDisabled: boolean;
  model: any = {};
  myDateValue: Date;
  factLanguage: any = {};
  arr: any[] = [];
  key_info: any = {};
  company_id: any = 0;
  edit_factoring_mode: any = false;
  modelexpiration_date: any = '';
  factReadOnly: boolean = true;
  currentUserRole: any = '';
  abc: any = [];
  assign_fact_mode = false;
  mobile_reminder_mode = false;
  assign_soa_mode = false;
  minDate: Date;
  maxDate: Date;
  customMinDate = new Date(2017, 5, 10);
  customMaxDate = new Date(2018, 9, 15);
  contentEditable = false;
  company_logo_path: any;
  imagePath: any = 'assets/images/users/profile_pic.png';
  width: number;
  height: number;
  check_height: number;
  msg: string = '';
  noticeOfAssignmentDoc: any;
  notice_of_assignment_doc_path_old: any;
  showpdficon: string;
  submitForm: FormGroup;
  constructor(private _company: CompanyService,
    private _factLang: FactLanguageService,
    private _router: Router,
    private toastr: ToastrService,
    private _activatedroute: ActivatedRoute,
    private EncrDecr: EncrDecrService,
    private formbuilder: FormBuilder,

  ) {
    this.minDate = new Date();
    this.maxDate = new Date();
    this.minDate.setDate(this.minDate.getDate() - 1);
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    // interface Window {
    //   webkitURL?: any;
    // }
  }
  get dynamicFields() {
    return this.submitForm.controls["dynamicFields"] as FormArray;
  }
  ngOnInit() {
    // document.getElementById('save_click').style.visibility = 'hidden';
    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');
    this.abc = localStorage.getItem('currentUser');
    var obj = JSON.parse(this.abc);
    this.currentUserRole = obj.role_name;
    this.get_company_by_id();

    this.myDateValue = new Date();

    this.submitForm = this.formbuilder.group({
      APIKEY: this.APIKEY,
      user_id: [localStorage.getItem('id')],
      company_id: [localStorage.getItem('company_id')],
      dynamicFields: this.formbuilder.array([]),
      advance_rate: '',
      inv_number: 'this.inv_number',
    });


    const dynamicFieldForm = this.formbuilder.group({
      id: [0],
      account_id: [0],
      is_primary_account: [true],
      account_name: [''],
      account_number: [''],
      description: [''],
      ach: [true],
      wire: [false],

    });
    //this.dynamicFields.push(dynamicFieldForm);
    document.getElementById('save_click').style.visibility = 'hidden';

  }

  public onSaveFactLang(value: boolean) {
    if (value == true) {
      this.model["edit_factoring"] = true;
    }
    else {
      this.model["edit_factoring"] = false;
    }
  }

  // accOnKey(event: any) {
  //   //this.model["email_per_invoice"] = event.target.value;
  // }

  onSubmit(form) {

    const formData = new FormData();
    this.model["company_id"] = this.company_id;
    this.model["user_id"] = this.user_id;
    this.model["APIKEY"] = this.APIKEY;
    this.model.company_logo_path = this.company_logo_path;

    formData.append('company_logo_path', this.company_logo_path);
    formData.append('company_logo_path_old', this.imagePath);
    var encrypted_id = this.EncrDecr.set(localStorage.getItem('key'), this.model["password"]);
    this.model["password"] = encrypted_id;


    formData.append('company_id', this.company_id);
    formData.append('APIKEY', this.model["APIKEY"]);
    formData.append('acc_email', this.model["acc_email"]);
    formData.append('address1', this.model["address1"]);
    formData.append('address2', this.model["address2"]);
    formData.append('address_id', this.model["address_id"]);
    formData.append('assign_fileupload', this.model["assign_fileupload"]);
    formData.append('assign_soa', this.model["assign_soa"]);
    formData.append('assigned_notice', this.model["assigned_notice"]);
    formData.append('c_id', this.model["c_id"]);
    formData.append('cc_email', this.model["cc_email"]);
    formData.append('city', this.model["city"]);
    formData.append('company_name', this.model["company_name"]);
    formData.append('contact_name', this.model["contact_name"]);
    formData.append('country', this.model["country"]);
    formData.append('created_at', this.model["created_at"]);
    formData.append('created_by', this.model["created_by"]);
    formData.append('delete_status', this.model["delete_status"]);
    formData.append('due_date', this.model["due_date"]);
    formData.append('edit_factoring', this.edit_factoring_mode);
    formData.append('email', this.model["email"]);
    formData.append('email_per_invoice', this.model["email_per_invoice"]);

    formData.append('expiration_date', this.model["expiration_date"]);
    formData.append('fact_address1', this.model["fact_address1"]);
    formData.append('fact_auth_person', this.model["fact_auth_person"]);
    formData.append('fact_city_state', this.model["fact_city_state"]);
    formData.append('fact_email', this.model["fact_email"]);
    formData.append('fact_id', this.model["fact_id"]);
    formData.append('fact_phone', this.model["fact_phone"]);
    formData.append('fact_soa_email', this.model["fact_soa_email"]);
    formData.append('finance_company', this.model["finance_company"]);
    formData.append('high_alert_email', this.model["high_alert_email"]);
    formData.append('instructions', this.model["instructions"]);
    // formData.append('mobile_reminder', this.model["mobile_reminder"]);

    formData.append('modified_at', this.model["modified_at"]);
    formData.append('modified_by', this.model["modified_by"]);
    formData.append('notification_email', this.model["notification_email"]);
    formData.append('owner_id', this.model["owner_id"]);
    formData.append('package_id', this.model["package_id"]);


    formData.append('password', this.model["password"]);
    formData.append('phone', this.model["phone"]);
    formData.append('recurring', this.model["recurring"]);
    formData.append('reminder_day_after', this.model["reminder_day_after"]);
    formData.append('reminder_day_before', this.model["reminder_day_before"]);
    formData.append('soa_assignment', this.model["soa_assignment"]);
    formData.append('stamp_location', this.model["stamp_location"]);
    formData.append('state', this.model["state"]);
    formData.append('status', this.model["status"]);
    formData.append('user_id', this.model["user_id"]);
    formData.append('zip', this.model["zip"]);
    formData.append('notice_of_assignment_doc_path', this.noticeOfAssignmentDoc);
    formData.append('notice_of_assignment_doc_path_old', this.notice_of_assignment_doc_path_old);
    this._company.updateCmp(formData)
      .subscribe(
        res => {
          if (res.status == true) {
            this.toastr.success(res.message, 'Success');
            window.location.reload();
          }
          else {
            this.toastr.error(res.message, 'Error');
          }
          this._router.navigate(['setting/company-profile/']);
        },
      );
  }

  public setAssignSoa(value: boolean) {
    if (value == true) {
      this.model["assign_soa"] = true;
    }
    else {
      this.model["assign_soa"] = false;
    }
  }

  // public updateItem(value: boolean) {
  //   if (value == true) {
  //     this.model["mobile_reminder"] = true;
  //   }
  //   else {
  //     this.model["mobile_reminder"] = false;
  //   }
  // }


  public setAssignFileupload(value: boolean) {
    if (value == true) {
      this.model["assign_fileupload"] = true;
    }
    else {
      this.model["assign_fileupload"] = false;
    }
  }

  get_company_by_id() {
    const data = {
      company_id: this.company_id,
      APIKEY: this.APIKEY
    }
    this._company.getCompanyById(data)
      .subscribe(
        res => {

          if (res.dataAccount.length > 0) {
            //this.dynamicFields.removeAt(0);
            for (let item of res.dataAccount) {
              if (item.is_ach == 0) {
                item.is_ach = false;
              } else {
                item.is_ach = true;
              }
              if (item.is_wire == 0) {
                item.is_wire = false;
              } else {
                item.is_wire = true;
              }
              const dynamicFieldForm = this.formbuilder.group({
                id: [0],
                account_id: item.account_id,
                is_primary_account: (item.is_primary_account == 1) ? true : false,
                account_name: item.account_name,
                account_number: item.account_number,
                description: item.description,
                ach: item.is_ach,
                wire: item.is_wire,
              });


              this.dynamicFields.push(dynamicFieldForm);
            }
          }

          if (res.data.edit_factoring == 1) {
            this.edit_factoring_mode = true;
            this.factReadOnly = false;
          }

          if (res.data.assign_soa == 1) {
            this.assign_soa_mode = true;
          }
          if (res.data.assign_fileupload == 1) {
            this.assign_fact_mode = true;
          }
          // if (res.data.mobile_reminder == 1) {
          //   this.mobile_reminder_mode = true;
          // }

          this.imagePath = res.data.company_logo_path;
          this.model = res.data;

          if (res.data.notice_of_assignment_doc_path == null || res.data.notice_of_assignment_doc_path == '') {
            this.model["notice_of_assignment_doc_path"] = '';
            this.showpdficon = 'no';
            this.notice_of_assignment_doc_path_old = '';
          }
          else {
            this.showpdficon = 'yes';
            this.model["notice_of_assignment_doc_path"] = res.data.notice_of_assignment_doc_path;
            this.notice_of_assignment_doc_path_old = res.data.notice_of_assignment_doc_path;
          }

          if (res.data.advance_rate == null) {
            this.submitForm.get('advance_rate').setValue('');
          } else {
            this.submitForm.get('advance_rate').setValue(res.data.advance_rate);
          }

          // this.model["assign_soa"] = res.data.assign_soa;
          // this.model["assign_fileupload"] = res.data.assign_fileupload;
          if (res.data.assign_soa == 1) {
            this.model["assign_soa"] = true;
          }
          else {
            this.model["assign_soa"] = false;
          }
          if (res.data.assign_fileupload == 1) {
            this.model["assign_fileupload"] = true;
          }
          else {
            this.model["assign_fileupload"] = false;
          }

          // this.model["mobile_reminder"] = res.data.mobile_reminder;
          this.model["password"] = this.EncrDecr.get(localStorage.getItem('key'), res.data.password);

          this.onChangeEvent(res.data.recurring);
        },
        err => console.log(err)
      );
  }

  myForm = new FormGroup({
    myDateYMD: new FormControl(new Date()),


  });

  weekshow: boolean = true;
  weekhide: boolean = false;
  dayshow: boolean = true;
  dayhide: boolean = false;
  onChangeEvent(value: any) {
    if (value == 'Weekly') {
      this.weekshow = true; this.weekhide = false;
    }
    else if (value == 'lastDay') {
      this.weekshow = false; this.weekhide = true;
    }

    this.model['recurring'] = value;
  }

  onChangeDays(value: any) {
    // if(value=='lastDay') {
    //  this.weekshow=false; this.weekhide=true;
    // }
    // else  {
    //    this.weekshow=true; this.weekhide=false;
    // }
    this.model['due_date'] = value;
  }


  onChangeReminderBefore(value: any) {
    this.model['reminder_day_before'] = value;
  }


  onChangeReminderAfter(value: any) {
    this.model['reminder_day_after'] = value;
  }

  onlyAlpha_numberic(evt) {
    // Only ASCII charactar in that range allowed 
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    //alert(ASCIICode);
    if ((ASCIICode >= 48 && ASCIICode <= 57) || (ASCIICode >= 65 && ASCIICode <= 90) || (ASCIICode >= 97 && ASCIICode <= 122) || ASCIICode == 38 || ASCIICode == 32 || ASCIICode == 39 || ASCIICode == 40 || ASCIICode == 41 || ASCIICode == 45 || ASCIICode == 44 || ASCIICode == 46)
      return true;
    return false;
  }

  onlyAlpha_numberic_address(evt) {

    // Only ASCII charactar in that range allowed 
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    //alert(ASCIICode);
    if ((ASCIICode >= 48 && ASCIICode <= 57) || (ASCIICode >= 65 && ASCIICode <= 90) || (ASCIICode >= 97 && ASCIICode <= 122) || ASCIICode == 38 || ASCIICode == 32 || ASCIICode == 39 || ASCIICode == 40 || ASCIICode == 41 || ASCIICode == 45 || ASCIICode == 44 || ASCIICode == 46 || ASCIICode == 35)
      return true;
    return false;
  }


  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {

      this.check_height = 0;

      // this.onChange(event);
      if (this.height > 535 || this.width > 800) {
        // alert("please select logo with height 500 and width 800");
        this.msg = 'Please select logo with height 533 and width 800';
        this.check_height = 1;
      }

      if (this.check_height == 0) {
        this.msg = '';
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]); // read file as data url
        reader.onload = (event: any) => {
          this.imagePath = event.target.result;
        }
        const file = event.target.files[0];

        this.company_logo_path = file;
        //this.model["company_logo_path"] = file;
      }
    }
  }

  onChange(fileInput: any) {
    //const URL = window.URL || window.webkitURL;
    if (fileInput.target.files[0].type == 'image/png' || fileInput.target.files[0].type == 'image/jpeg' || fileInput.target.files[0].type == 'image/jpg' || fileInput.target.files[0].type == 'image/bmp' || fileInput.target.files[0].type == 'image/gif' || fileInput.target.files[0].type == 'image/tif' || fileInput.target.files[0].type == 'image/tiff' || fileInput.target.files[0].type == 'image/svg' || fileInput.target.files[0].type == 'image/webp') {
      const URL = window.URL;
      const Img = new Image();
      console.log(fileInput);
      const filesToUpload = (fileInput.target.files);
      Img.src = URL.createObjectURL(filesToUpload[0]);

      Img.onload = (e: any) => {
        this.height = Img.height;
        this.width = Img.width;

        setTimeout(() => {
          this.onSelectFile(fileInput);
        }, 300);
      }
    } else {
      alert('Only Images are allowed');
      $("#company_logo_path").val('');
      this.company_logo_path = '';
      this.msg = '';
    }
  }


  delete_companylogo() {

    var delBtn = confirm(" Do you want to delete ?");
    if (delBtn == true) {
      const data = {
        company_id: this.company_id,
        APIKEY: this.APIKEY
      }
      this._company.delete_companylogo(data)
        .subscribe(
          res => {
            if (res.status == true) {
              this.toastr.success(res.message, 'Success');
              this.imagePath = '';
              $("#company_logo_path").val('');
              this.company_logo_path = '';
              this.msg = '';
            }


          },
          err => console.log(err)
        );
    }

  }
  submit_form() {
    $("#save_click").click();
  }

  // onFileChange(event) {
  //   this.noticeOfAssignmentDoc = event.target.files[0];
  // }

}



